declare namespace $ {

	type $bog_theme_auto__themes_bog_ainews_app_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_theme_auto['themes'] >
	>
	type $bog_theme_auto__theme_light_bog_ainews_app_2 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_theme_auto['theme_light'] >
	>
	type $bog_theme_auto__theme_dark_bog_ainews_app_3 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_theme_auto['theme_dark'] >
	>
	type $mol_paragraph__title_bog_ainews_app_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_ainews_app_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_page__title_bog_ainews_app_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_bog_ainews_app_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	export class $bog_ainews_app extends $mol_book2_catalog {
		Lights( ): $mol_lights_toggle
		Theme( ): $bog_theme_auto
		Feed( ): $bog_ainews_app_feed
		Favorite( ): $bog_ainews_app_favorites
		Sources( ): $bog_ainews_app_sources
		Filters( ): $bog_ainews_app_filters
		Settings( ): $bog_ainews_app_settings
		Feat_1( ): $mol_paragraph
		Feat_2( ): $mol_paragraph
		Features( ): $mol_page
		Placeholder( ): any
		Menu_logo( ): $mol_icon_newspaper
		menu_title( ): string
		menu_tools( ): readonly(any)[]
		plugins( ): readonly(any)[]
		spreads( ): ({ 
			'': ReturnType< $bog_ainews_app['Feed'] >,
			'favorite': ReturnType< $bog_ainews_app['Favorite'] >,
			'sources': ReturnType< $bog_ainews_app['Sources'] >,
			'filters': ReturnType< $bog_ainews_app['Filters'] >,
			'settings': ReturnType< $bog_ainews_app['Settings'] >,
			'features': ReturnType< $bog_ainews_app['Features'] >,
		}) 
	}
	
}

//# sourceMappingURL=app.view.tree.d.ts.map